/**
 * Function that takes user input and returns a cleaned version
 * in case user inputs column name in format df["boyta"] instead of just "boyta"
 */
export function cleanColumnName(c: string) {
  return c.replace(/df\["(.+)"\]|df\['(.+)'\]/, "$1$2");
}
